(() => {
  if (window.eoneResourcesFlyoutLoaded) return;
  window.eoneResourcesFlyoutLoaded = true;
  const mode = window.matchMedia('(min-width: 990px) and (min-height: 600px) and (hover: hover) and (pointer: fine)');

  function setup(scope = document) {
    scope.querySelectorAll('header-menu[data-eone-resources-menu]').forEach((host) => {
      if (host.dataset.flyoutReady) return;
      const root = host.querySelector(':scope > details');
      const trigger = root?.querySelector(':scope > summary');
      const list = root?.querySelector(':scope > ul');
      if (!root || !trigger || !list) return;
      host.dataset.flyoutReady = 'true';
      const rows = [...list.children];
      const groups = rows.map((row) => row.querySelector(':scope > details')).filter(Boolean);
      let closeTimer;
      let selectTimer;
      let suppressFocus = false;

      const clearTimers = () => {
        window.clearTimeout(closeTimer);
        window.clearTimeout(selectTimer);
      };

      function setOpen(details, open) {
        details.open = open;
        details.classList.toggle('menu-opening', open);
        details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(open));
      }

      function place() {
        const rect = host.getBoundingClientRect();
        const width = document.documentElement.clientWidth;
        const left = Math.max(12, Math.min(rect.left, width - 284));
        host.style.setProperty('--eone-resource-offset', `${left - rect.left}px`);
        host.dataset.flyoutSide = left + 272 + 320 <= width - 12 ? 'right' : 'left';
        host.style.setProperty('--eone-resource-height', `${Math.max(220, window.innerHeight - list.getBoundingClientRect().top - 16)}px`);
      }

      function openRoot() {
        if (!mode.matches) return;
        window.clearTimeout(closeTimer);
        document.querySelectorAll('.header__inline-menu header-menu > details[open]').forEach((other) => {
          if (other !== root) setOpen(other, false);
        });
        setOpen(root, true);
        place();
      }

      function choose(group) {
        window.clearTimeout(selectTimer);
        groups.forEach((item) => setOpen(item, item === group));
        place();
      }

      function closeRoot() {
        clearTimers();
        groups.forEach((item) => setOpen(item, false));
        setOpen(root, false);
      }

      function focus(node) {
        suppressFocus = true;
        node?.focus();
        suppressFocus = false;
      }

      host.addEventListener('pointerenter', openRoot);
      host.addEventListener('pointerleave', () => {
        if (!mode.matches) return;
        clearTimers();
        closeTimer = window.setTimeout(() => {
          if (!host.contains(document.activeElement)) closeRoot();
        }, 200);
      });

      rows.forEach((row) => {
        row.addEventListener('pointerenter', () => {
          if (!mode.matches) return;
          clearTimers();
          const group = row.querySelector(':scope > details');
          selectTimer = window.setTimeout(() => choose(group), 100);
        });
        row.addEventListener('pointerleave', () => window.clearTimeout(selectTimer));
      });

      host.addEventListener('focusin', (event) => {
        if (!mode.matches || suppressFocus) return;
        clearTimers();
        openRoot();
        const group = groups.find((item) => item.contains(event.target));
        if (event.target !== trigger) choose(group || null);
      });

      host.addEventListener('focusout', () => {
        if (!mode.matches) return;
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          if (!host.contains(document.activeElement) && !host.matches(':hover')) closeRoot();
        }, 0);
      });

      // Own only this menu's disclosure clicks; links retain their native navigation.
      host.addEventListener('click', (event) => {
        if (!mode.matches) return;
        const summary = event.target.closest('summary');
        const details = summary?.parentElement;
        if (details !== root && !groups.includes(details)) return;
        event.preventDefault();
        event.stopPropagation();
        if (details === root) {
          if (root.open && event.detail === 0) closeRoot();
          else openRoot();
        } else {
          choose(details.open && event.detail === 0 ? null : details);
        }
      }, true);

      host.addEventListener('keydown', (event) => {
        if (!mode.matches) return;
        const group = groups.find((item) => item.contains(event.target));
        const summary = group?.querySelector(':scope > summary');
        const enterKey = host.dataset.flyoutSide === 'left' ? 'ArrowLeft' : 'ArrowRight';
        const exitKey = host.dataset.flyoutSide === 'left' ? 'ArrowRight' : 'ArrowLeft';
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          if (group?.open) {
            choose(null);
            focus(summary);
          } else {
            closeRoot();
            focus(trigger);
          }
        } else if (group && event.target === summary && event.key === enterKey) {
          event.preventDefault();
          event.stopPropagation();
          choose(group);
          focus(group.querySelector('ul a'));
        } else if (group && event.target !== summary && event.key === exitKey) {
          event.preventDefault();
          event.stopPropagation();
          choose(null);
          focus(summary);
        } else if (event.target === trigger && event.key === 'ArrowDown') {
          event.preventDefault();
          event.stopPropagation();
          openRoot();
          rows[0]?.querySelector('summary, a')?.focus();
        }
      }, true);

      host.addEventListener('keyup', (event) => {
        if (mode.matches && event.key === 'Escape') event.stopPropagation();
      }, true);

      document.addEventListener('pointerdown', (event) => {
        if (mode.matches && !host.contains(event.target)) closeRoot();
      });
      root.addEventListener('toggle', () => {
        if (!root.open) {
          clearTimers();
          groups.forEach((item) => setOpen(item, false));
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
      const syncMode = () => {
        closeRoot();
        host.classList.toggle('eone-resources-flyout', mode.matches);
      };
      mode.addEventListener('change', syncMode);
      window.addEventListener('resize', () => {
        if (mode.matches && root.open) place();
      });
      syncMode();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
